<template>
    <div class="p-3">
        <div class="createQuestion">
            <h5 class="text-center pb-4">{{ $t('question_list.label.explain_answer') }}</h5>
            <div class="explain">
                <div class="explain-textArena">
          <textarea
              name=""
              id=""
              rows="5"
              maxlength="1500"
              class="answer-input__text_explain mt-2"
              disabled="true"
              color="color:black"
              v-model="editQuestion.data.explain"
          ></textarea>
                    <!-- <span>{{ totalCharacterExplain }} / 1500</span> -->
                </div>
                <div class="row justify-content-around">
                    <div class="col left-embed p-0">
                        <div
                            class="d-flex flex-column align-items-center embed-image-video"
                        >
                            <div  id="preview" class="">
                                <img
                                    v-if="!editQuestion.data.explain_s3"
                                    src="../../assets/images/404.jpg"
                                />
                                <img
                                    v-if="editQuestion.data.explain_s3 && isImage === true"
                                    :src="editQuestion.data.explain_s3"
                                />
                                <div class="question_explain_pdf">
                                    <a v-if="editQuestion.data.explain_s3 && isImage === false" :href="editQuestion.data.explain_s3">
                                        <img
                                            style="width:200px"
                                            src="../../assets/images/file_pdf.svg.webp"
                                        />
                                        <p>
                                            {{ namePdf }}
                                        </p>
                                    </a>
                                </div>

                            </div>
                            <!--                            5-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 float-right">
                <b-button @click="hideModal" variant="danger">{{ $t('question_list.label.close') }}</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    data() {
        return {
            totalCharacterExplain: 0,
            isImage: null,
            namePdf: null,
        };
    },
    computed: {
        ...mapState("question", ["editQuestion",])
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("modal-explain-detail");
        },
    },
    async created() {
        let questionEdit = this.editQuestion.data;
        if (questionEdit.explain) {
            this.totalCharacterExplain = questionEdit.explain.length;
        }
        if (questionEdit.explain_path) {
            this.fileExplain_img = this.explain_img_preview;
            this.fileExplain_pdf = this.explain_pdf_preview;

            if (this.editQuestion.data.explain_path.includes(".pdf")) {
                this.isImage = false;
                this.namePdf = this.editQuestion.data.explain_path.substr(13);
            } else {
                this.isImage = true;
            }
        }
    }
};
</script>
<style>
@import "../../assets/scss/Questions.scss";

* {
    font-size: 15px;
}
.explain {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    padding: 21px;
}
.explain-textArena {
    position: relative;
    margin: 20px 0px;
}

.explain-textArena textarea {
    padding: 10px;
    border-radius: 2px;
}
.explain-textArena span {
    position: absolute;
    right: 10px;
    bottom: 10px;
}
</style>
